import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/@core/http/login';
import { UserInfoModel, Role, LocalStorageKey } from 'src/@core/http/login/login.model';
import { Router } from '@angular/router';
import { AuthService } from 'src/@core/http/auth/auth.service';

@Component({
    selector: 'app-terms',
    templateUrl: 'terms.component.html',
    styleUrls: ['terms.component.scss'],
})

export class TermsComponent {
    public isAgree: boolean;
    constructor(private service: LoginService,
        private authService: AuthService,
        private router: Router) {
            this.checkAuthentication();
    }

    private checkAuthentication() {
        if (!this.authService.IsAuthenticate) {
            this.router.navigateByUrl('login');
        }
    }

    public nextBtnClick() {
        this.service.firstLogin().subscribe(result => {
            this.authService.getCurrentUser().subscribe(user => {
                    if (user.roles.find(r => r === Role.Admin)) {
                        this.router.navigateByUrl('admin');
                    } else {
                        this.router.navigateByUrl('customer');
                    }
                },
                error => {
                    console.log(error);
                });
            });
    }

    public onChange(isAgree) {
        this.isAgree = isAgree;
    }
}
